/*
  Applies the first-order subscription discount code (theme setting "Subscription discount code")
  whenever the cart holds a subscription, and removes it when it no longer does.
  Shopify enforces the code's own rules at checkout (subscriptions only, first payment, one use per customer).
*/
(function () {
  const code = (window.blackerSubscribeCode || '').trim();
  if (!code) return;

  const lower = code.toLowerCase();
  let syncing = false;

  async function sync() {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await fetch(`${window.routes ? window.routes.cart_url : '/cart'}.js`).then((r) => r.json());
      const hasSubscription = cart.items.some((item) => item.selling_plan_allocation);
      const codes = (cart.discount_codes || []).map((d) => d.code);
      const applied = codes.some((c) => c.toLowerCase() === lower);

      let next = null;
      if (hasSubscription && !applied) next = [...codes, code];
      if (!hasSubscription && applied) next = codes.filter((c) => c.toLowerCase() !== lower);
      if (next === null) return;

      const drawer = document.querySelector('cart-drawer');
      const onCartPage = document.querySelector('cart-items:not(cart-drawer-items)');
      const body = { discount: next.join(',') };
      if (drawer && !onCartPage) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(`${window.routes ? window.routes.cart_update_url : '/cart/update'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then((r) => r.json());

      if (onCartPage) {
        window.location.reload();
      } else if (drawer && response.sections && drawer.classList.contains('active')) {
        drawer.renderContents(response);
      }
    } catch (error) {
      console.error('Blacker subscription code:', error);
    } finally {
      syncing = false;
    }
  }

  document.addEventListener('DOMContentLoaded', sync);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(sync, 50));
  }
})();
